import React from "react";
import Spacer from "@components/Spacer";

// Oylan: Russian About window. The OATutor credit stays, as the MIT license requires.
const About = () => {
    return <>
        <h2>О приложении</h2>
        Oylan помогает учиться решать олимпиадные задачи по математике для 3 класса.
        Если задача не получается, открой подсказку. Подсказки открываются по одной,
        готовый ответ приложение не показывает.

        <h3>Как отвечать</h3>
        Впиши число в поле и нажми «Проверить» или клавишу Enter. Если есть варианты ответа,
        выбери один из них.

        <Spacer height={24}/>

        <sub>
            <p>
                Приложение построено на открытом проекте <a href="https://github.com/CAHLR/OATutor" target={"_blank"} rel={"noreferrer"}>OATutor</a>,
                его создала лаборатория CAHL Research Lab, UC Berkeley School of Education. Код OATutor распространяется по лицензии MIT.
            </p>
        </sub>
    </>
}

export default About
